import { InjectionToken } from '@angular/core';
import { IRadiationService } from './radiation-service.interface';

export const RADIATION_SERVICE = new InjectionToken<IRadiationService>(
  'RADIATION_SERVICE'
);
